import React from 'react';
import { SectionLabel } from './SectionLabel';
export function Hook() {
  return <section className="w-full border-y border-ink/10 bg-oat/50" data-id="element-72" data-mp="2b624qli8oqlt">
      <div className="mx-auto w-full max-w-3xl px-5 py-12 sm:px-6 sm:py-16 lg:py-24" data-id="element-73" data-mp="2b48ukw8f3o92">
        <SectionLabel data-id="element-74" data-mp="1x8585p3sck75">El gancho</SectionLabel>
        <h2 className="font-display text-[1.6rem] leading-tight text-ink sm:text-4xl" data-id="element-75" data-mp="217w0hx8yn8ds">
          ¿Alguna vez te detuviste a leer la etiqueta de los jabones que comprás
          en el súper?
        </h2>
        <p className="mt-5 font-sans text-[15px] leading-relaxed text-ink/70 sm:mt-6 sm:text-lg" data-id="element-76" data-mp="2txcrcqgxmh7w">
          Están llenos de detergentes sintéticos, conservantes y fragancias
          artificiales que irritan la piel, causan alergias y eliminan la
          hidratación natural.
        </p>
        <p className="mt-5 border-l-2 border-clay pl-4 font-display text-lg italic leading-relaxed text-ink/85 sm:pl-5 sm:text-2xl" data-id="element-77" data-mp="37wulzmgwsop6">
          Pero hay otra forma. Una forma donde vos tenés el control. Donde podés
          usar aceites naturales, hierbas, arcillas y aromas puros para crear una
          pieza que no solo limpia, sino que sana y embellece.
        </p>
      </div>
    </section>;
}